import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FogComponent } from './fog/fog.component';
import { FooterComponent } from './footer/footer.component';
import { OverviewComponent } from './overview/overview.component';
import { StartComponent } from './start/start.component';
import { ModalComponent } from './overview/modal/modal.component';
import { SlideComponent } from './overview/slide/slide.component';
import { TimelineComponent } from './overview/timeline/timeline.component';
import { TreeComponent } from './overview/tree/tree.component';

@NgModule({
  declarations: [
    AppComponent,
    FogComponent,
    FooterComponent,
    OverviewComponent,
    StartComponent,
    ModalComponent,
    SlideComponent,
    TimelineComponent,
    TreeComponent
  ],
  imports: [
    BrowserModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
